<template>
  <div>
    <section class="orderSect">
      <!--S 检索-->      
      <el-form inline :model="formInline">
        <el-form-item :label="expecttitle">
          <el-date-picker 
          v-model="formInline.expectedDelvDate" 
          type="daterange"          
          range-separater="至" 
          start-placeholder="开始日期" 
          end-placeholder="结束日期"
          :picker-options="formInline.orderDateOptions"
          :unlink-panels = "true" clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-if="sppsfw == 1" v-model="formInline.timeSlot" placeholder="请选择" class="formTimeSlot" clearable>
            <el-option label="中午" value="09:00:00"></el-option>
            <el-option label="晚上" value="15:00:00"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号" class="codeSerIpt">
          <el-input v-model="formInline.orderno" placeholder="请输入订单号" clearable></el-input>
        </el-form-item>
        <el-form-item label="收货人">
            <el-input  v-model="formInline.Name" placeholder="请输入收货人" clearable></el-input>
          </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="formInline.phone" placeholder="请输入手机号码" clearable></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="getLeakExps">查询</el-button>
        </el-form-item>
        <em class="simpleSearch" @click="highShow = !highShow">{{highShow?'精简筛选':'高级筛选'}}</em>
        <div class="none" :class="{'block':highShow}">
          <!-- 配送方下拉组件 S -->
          <DeliveryAreaSelect @deliveryObtain="deliveryReceive"></DeliveryAreaSelect>
          <!-- 配送方下拉组件 E -->
          <!-- 订单归属下拉组件 S -->
          <OrderAscription @belongObtain="belongReceive" title="代销方" cootype="0"></OrderAscription>
          <!-- 订单归属下拉组件 E -->
        </div>   
      </el-form>
    <!--E 检索-->

    <!--S 全部快递列表-->
    <div class="allOrderTab individualiz">
      <el-form :model="formInline" inline size="medium">
        <el-form-item class="borderline">
          <el-button type="primary" @click="continuePrnt()">继续打印</el-button>
          <i class="iconwh" v-popover:continuePrntPop></i>
          <el-popover placement="top" width="220" trigger="hover" ref="continuePrntPop">
            <p class="greyColor">快速匹配当前列表第一个快递所在的打印批次，继续完成打印任务</p>
          </el-popover>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="getPrinted(1)">检索打印</el-button>
          <el-button type="primary" plain @click="getPrinted(0)">勾选打印</el-button>
        </el-form-item>                            
      </el-form>
      <el-table v-loading="loading" :data="allExpressData" ref="expressTable" class="orderTable comTable" border :maxHeight="tableHeight" @selection-change="handleSelectionChange">       
        <el-table-column type="selection" fixed></el-table-column>
        <el-table-column type="index" label="序号" fixed></el-table-column>
        <el-table-column label="订单信息" prop="expcontent" sortable fixed min-width="300">
          <template slot-scope="scope">
            <small>订单号：{{scope.row.orderno}}</small>
            <p class="textFl" :title="scope.row.expcontent">{{scope.row.expcontent}}</p>
            <small>{{expecttitle}}：{{dateTime(scope.row.recvdate, 2)}}</small>
          </template>
        </el-table-column>
        <el-table-column label="收货信息" sortable prop="fulladdr" min-width="300">
          <template slot-scope="scope">
            <div class="shouMsg">
              <em v-if="scope.row.receivername">{{scope.row.receivername}}</em>
              <em v-if="scope.row.receivertel">{{scope.row.receivertel}}</em>
            </div>              
            <p v-if="scope.row.fulladdr" class="greyColor textFl" :title="scope.row.fulladdr">{{scope.row.fulladdr}}</p>
          </template>
        </el-table-column>
        <el-table-column label="发货状态" width="150" sortable prop="deliverstate">
          <template slot-scope="scope">
            <span :class="[{'blueColor':scope.row.deliverstate==1 || scope.row.deliverstate==3},{'orangeColor':scope.row.deliverstate==0},{'redColor':scope.row.deliverstate==2 || scope.row.deliverstate==6},{'greyColor':scope.row.deliverstate==4},{'greenColor':scope.row.deliverstate==5}]">{{scope.row.deliverstate | deliverStateFilter}}</span>
          </template>
        </el-table-column> 
        <el-table-column label="打印状态" width="150" sortable prop="bprint">
          <template slot-scope="scope">
            <span v-if="scope.row.bprint == 0" class="orangeColor">待打印</span>
            <span v-if="scope.row.bprint == 1" class="blueColor">已打印</span>
          </template>
        </el-table-column>
        <el-table-column label="打印类别" width="200" sortable prop="handletype">
          <template slot-scope="scope">
            <span>{{scope.row.handletype | handleTypeFilter}}</span>
          </template>
        </el-table-column>  
        <el-table-column label="筛单状态" width="180" sortable prop="screenstate">
          <template slot-scope="scope">
            <p :class="scope.row.screenstate | screenStateColorFilter">{{scope.row.screenstate | screenStateFilter}}</p>
            <small v-if="scope.row.returnmsg" class="txtLineTwo pdr30" :title="scope.row.returnmsg">{{scope.row.returnmsg}}</small>
          </template>
        </el-table-column>
        <!-- <el-table-column label="下单类型" width="150" sortable prop="ordtype">
          <template slot-scope="scope">
            <span>{{scope.row.ordtype | ordtype}}</span>
          </template>
        </el-table-column>  -->
        <template slot="empty">
          <div class="noData"><span>暂无数据</span></div>
        </template>
      </el-table>
    </div>
    <!--E 全部快递列表-->
    <Page :pageTotal="pagebean.totalnum" :currentPage="pagebean.currentpage" @nowPageParam="setPageparam"></Page>
    </section>

    <!--S 勾选打印组件-->
    <PrintInfo :printInfoBox="printInfoShow" :operatePrint="batchOperate" @printTypeVal="getPrintType" @closePrintVal="clsPrintVal" @closePrintBox="closePrintInfo"></PrintInfo>
    <!--E 勾选打印组件-->
    
  </div>
</template>
<script>
import { Message, MessageBox } from "element-ui";
import api from '../../apis/api';
export default {
  name: "AllOrder",
  data() {
    return {
      highShow: false, //是否展示高级筛选
      deliveryList: [], //配送方列表
      ConsignmentLists: [], //代销方列表
      //检索
      formInline: {
        Name: "", //收货人        
        orderno: "", //订单号
        phone: "", //手机号
        expectedDelvDate: "", //期望发货日期
        timeSlot: "", //全天、中午、晚上时间段选择
        consigner: "", //代销方
        deliveryer: "", //配送方    
        orderDateOptions: {
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime());
                picker.$emit("pick", [start, end]);
              }
            },{
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              }
            }
          ]
        }
      },
      allExpressData: [], //全部快递数据
      multipleSelection: [], //已选中的行
      tableHeight: window.innerHeight * 0.8, //表格动态高度
      batchOperate:0,//打印操作 0:筛选打印；1:勾选打印；2：excel导入
      printInfoShow:false, //勾选打印弹窗
      printBtnVal:'', //勾选打印按钮关闭还是确定
      printType:'', //打印类别
      pagebean: {
        pagesize: 30,
        currentpage: 1
      },//分页
      loading: true,//加载
      exptypes: {},//所有的快递方式
      expcode: '',//快递编号
      ordernoArr: [],
      expecttitle: '',//期望发货日期标题
      sppsfw: 0,//是否开通同城配送
      patchName: '', // 获取上一个页面的name
      subNow: 0,//立即下单
    };
  },
  watch: {
    '$route'(to,from) {
      this.patchName = from.name;
    }
  },
  components: {
    Page: () => import("@/components/common/Page.vue"),
    PrintInfo: () => import("@/components/DeliveryFolder/PrintInfo.vue"), //勾选打印组件
    DeliveryAreaSelect: () => import("@/components/common/DeliveryAreaSelect.vue"), // 配送方下拉组件
    OrderAscription: () => import("@/components/common/OrderAscription.vue"), // 订单归属下拉组件
  },
  methods: {
    // 订单归属下拉选择值
    belongReceive(value) {
      this.formInline.consigner = value;
    },
    // 配送方下拉选择值
    deliveryReceive(value) {
      this.formInline.deliveryer = value;
    },
    //表格多选选中行复制
    handleSelectionChange(val) { 
      this.multipleSelection = val;
    },
    //继续打印
    continuePrnt(){
      let exp = this.allExpressData[0]
      //存储批次编号
      let expgenbatchnoArr = []
      expgenbatchnoArr.push(exp.expgenbatchno)
      sessionStorage.setItem('expgenbatchnoArr', JSON.stringify(expgenbatchnoArr))
      this.$router.push({
        name:'针式热敏打印列表',
        params: {
          printType: exp.handletype ? exp.handletype : '1000',
        }
      });
    },
    //打印操作
    getPrinted(val) {
      this.batchOperate = val; //打印操作类型
      if(val == 0){
        if(this.multipleSelection.length > 0){
          this.printInfoShow = true;
        }else{
          MessageBox.alert("请选择要打印的订单！", "系统提示", {
            confirmButtonText: "确定",
            type:'warning'
          }).then(() => {}).catch(() => {});
        }
      }else{
        this.printInfoShow = true;
      }
    },
    //获取打印类别
    getPrintType(val){
      this.printType = val;
    },
    //勾选打印是确定还是取消
    clsPrintVal(val){
      this.printBtnVal = val;
    },
    //关闭勾选打印弹窗
    closePrintInfo(type, value, memo, fileUrl, subNow){
      this.printInfoShow = false; //弹窗
      if(type == 1) {
        this.printType = value ;
        this.genbatchmemo = memo;
        this.subNow = subNow;
        //遍历选中的订单号
        if(this.batchOperate == 0) {
          this.multipleSelection.forEach(item => {
            this.ordernoArr.push(item.expcode)
          })
        }
        if(this.batchOperate == 0 || this.batchOperate == 1) {
          //调用生成快递的接口
          this.orderPrint()
        } else if (this.batchOperate == 2) {
          //excel导入
          this.importOrder(fileUrl)
        }
      }
    },
    //检索/勾选打印
    orderPrint() {
      this.loading = true
      let params = {
        isLeak: 1,//漏单打印
        printType: this.batchOperate,
        selprintType: this.printType,
        genbatchmemo: this.genbatchmemo,

        //勾选内容
        ordernoArr: this.batchOperate == 0 ? this.ordernoArr : '',

        //检索条件
        stardate: this.formInline.expectedDelvDate && this.formInline.expectedDelvDate[0] ? this.dateTime(this.formInline.expectedDelvDate[0]) : '',
        enddate: this.formInline.expectedDelvDate && this.formInline.expectedDelvDate[1] ? this.dateTime(this.formInline.expectedDelvDate[1]) : '',
        dateAmPm: this.formInline.timeSlot, //中午、晚上时间段选择
        orderno: this.formInline.orderno, //订单号
        name: this.formInline.Name, //收货人/提货人
        mobileNumber: this.formInline.phone, //手机号
        delivery: this.formInline.deliveryer, //配送方
        proxyqydm: this.formInline.consigner, //订单归属
      }
      api.ORDERPRINT(params).then(res => {
        if(res.data.status == '200') {
          Message({
            type: 'success',
            message: '快递生成成功!'
          });
          //非erp跳转热敏打印页面
          if(this.printType != '1004' && this.printType != '1005' && this.printType != '1006' && this.printType != '1007' && this.printType != '1009') {
            //存储批次编号
            let expgenbatchnoArr = []
            expgenbatchnoArr.push(res.data.data.expgenbatchno)
            sessionStorage.setItem('expgenbatchnoArr', JSON.stringify(expgenbatchnoArr))
            this.$router.push({
              name:'针式热敏打印列表',
              params: {
                printType: this.printType,
              }
            });
          } else {
            let type = this.printType == '1004' ? 2 : (this.printType == '1005' ? 1 : (this.printType == '1006' ? 0 : (this.printType == '1009'?5:3)))
            this.$router.push({
              name:'ERP发货记录',
              query: {
                type: type,
                subNow: this.subNow,
              }
            });
          }
        } else {
          Message({
            type: 'error',
            message: res.data.message
          });
        }
        this.ordernoArr = []
        this.loading = false
      })
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.expressTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130;
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
    },

    //设置分页数据
    setPageparam(nowPageSize, nowCurrentPage) {
      if(nowPageSize) {
        this.pagebean.pagesize = nowPageSize
      }
      if(nowCurrentPage) {
        this.pagebean.currentpage = nowCurrentPage
      }
      this.getLeakExps()
    },

    //查询漏单列表
    getLeakExps() {
      this.loading = true
      let params = {
        stardate: this.formInline.expectedDelvDate && this.formInline.expectedDelvDate[0] ? this.dateTime(this.formInline.expectedDelvDate[0]) : '',
        enddate: this.formInline.expectedDelvDate && this.formInline.expectedDelvDate[1] ? this.dateTime(this.formInline.expectedDelvDate[1]) : '',
        dateAmPm: this.formInline.timeSlot,
        orderno: this.formInline.orderno, //订单号
        name: this.formInline.Name,
        mobileNumber: this.formInline.phone,
        expcode: '',
        expresscode: this.formInline.deliveryer,//配送方
        proxyqydm: this.formInline.consigner,//代销方
        pageparam: this.pagebean
      }
      api.GET_LEAKEXPINFOLIST(params).then(res => {
        this.toTableTop('expressTable');
        if(res.data.status == '200') {
          this.allExpressData = res.data.data
          this.pagebean = res.data.pagebean
        } else {
          this.allExpressData = []
        }
        this.loading = false
      })
    },

    //获取所有的可用快递方式
    getAllExpTypes() {
      if(localStorage.getItem("exptypes")){
        this.exptypes = JSON.parse(localStorage.getItem("exptypes"))
      }else{
        api.GET_ALLEXPMODENAMECACHE({}).then(res => {
        if(res.data.status == '200') {
          this.exptypes = res.data.data.expmodeMap
          localStorage.setItem("exptypes",JSON.stringify(this.exptypes))
        }
        })
      }
    },
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    //在dom渲染之后
    setTimeout(() => {
      this.getHeight()
      this.getAllExpTypes()
      this.getLeakExps()
      this.expecttitle = localStorage.getItem("pubordprintinfo") ? JSON.parse(localStorage.getItem("pubordprintinfo")).expecttitle : ''
    }, 200);
    this.sppsfw = this.ElementControls('sppsfw')
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight); //销毁监听浏览器视窗变化
  },
  activated() {
    if(this.patchName != '针式热敏打印列表') {
      if(this.patchName) {
        Object.assign(this.$data, this.$options.data());
        //在dom渲染之后
        setTimeout(() => {
          this.getHeight()
          this.getAllExpTypes()
          this.getLeakExps()
          this.expecttitle = localStorage.getItem("pubordprintinfo") ? JSON.parse(localStorage.getItem("pubordprintinfo")).expecttitle : ''
        }, 200);
        this.sppsfw = this.ElementControls('sppsfw')
      }
    } else {
      this.getLeakExps()
    }
  },
};
</script>

<style scoped>
@import "Css/Style.css";
.iconwh { font-size: 16px; color: #ccc;margin-left: 5px;cursor: pointer;}
.individualiz >>> .el-form {padding-top:10px!important;}
</style>





// WEBPACK FOOTER //
// src/views/DeliveryFolder/MissingExpressList.vue